import { NavigateFunction } from 'react-router-dom';

import { routePaths } from '@shared/router/routePaths';
import { CampaignId } from '@shared/types/campaign';
import { logError } from '@shared/utils/logError.ts';
import { navigateTo } from '@shared/utils/navigateTo';

export const createRedirectToEditFormHandler = (navigate: NavigateFunction, campaignId: CampaignId) => {
  return () => {
    void navigateTo(navigate, routePaths.campaignBuilderStep01.url(campaignId), {
      state: routePaths.campaignDetails.url(campaignId),
    }).catch(logError);
  };
};
